import { useState, useEffect, useRef } from "react";
import "./Reconciliation.css";

const API = "/api/reconciliation";

function getMonthOptions() {
  const options = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d    = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const label = d.toLocaleString("ru-RU", { month: "long", year: "numeric" });
    const from  = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-01`;
    const last  = new Date(d.getFullYear(), d.getMonth()+1, 0).getDate();
    const to    = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(last).padStart(2,"0")}`;
    options.push({ label, from, to });
  }
  return options;
}

const STATUS_ICON  = { running:"⏳", done:"✅", error:"❌" };
const STATUS_LABEL = { running:"Выполняется...", done:"Готово", error:"Ошибка" };

export default function ReconciliationMain({ user, token, onLogout }) {
  const [bkList,      setBkList]      = useState([]);
  const [hotels,      setHotels]      = useState([]);
  const [selectedBk,  setSelectedBk]  = useState("");
  const [selectedHotel, setSelectedHotel] = useState("all");
  const [periodIdx,   setPeriodIdx]   = useState(0);
  const [useQwen,     setUseQwen]     = useState(true);
  const [currentJob,  setCurrentJob]  = useState(null);
  const [history,     setHistory]     = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [error,       setError]       = useState("");
  const [uploadMode,  setUploadMode]  = useState(false);
  const [uploadFile,  setUploadFile]  = useState(null);
  const [customPeriod, setCustomPeriod] = useState(false);
  const [dateFrom,    setDateFrom]    = useState("");
  const [dateTo,      setDateTo]      = useState("");
  const [diadokMode,  setDiadokMode]  = useState(false);
  const pollRef = useRef(null);
  const monthOptions = getMonthOptions();
  const headers = { "Authorization": `Bearer ${token}`, "Content-Type": "application/json" };

  useEffect(() => {
    if (!token) return;

    fetch(`${API}/bk-list`, { headers })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          setBkList(data);
          if (data.length) setSelectedBk(data[0].slug);
        }
      })
      .catch(() => setError("Не удалось загрузить список БК"));

    fetch(`${API}/hotels`, { headers })
      .then(r => r.json())
      .then(data => { if (Array.isArray(data)) setHotels(data); })
      .catch(() => {});

    loadHistory();
  }, [token]);

  const handleRunDiadok = async () => {
    setError(""); setLoading(true);
    const period = monthOptions[periodIdx];
    // Определяем org_id из выбранного отеля
    const selectedHotelObj = hotels.find(h => String(h.id) === String(selectedHotel));
    const org_id = selectedHotelObj?.diadok_org_id || null;
    try {
      const res = await fetch(`${API}/run-diadok`, {
        method: "POST",
        headers,
        body: JSON.stringify({
          bk_slug: selectedBk,
          date_from: period.from,
          date_to: period.to,
          use_qwen: useQwen,
          org_id: org_id,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Ошибка");
      setCurrentJob({ job_id: data.job_id, status: "running", bk_slug: selectedBk, date_from: period.from, date_to: period.to });
    } catch(e) { setError(e.message); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    if (currentJob?.status === "running") {
      pollRef.current = setInterval(() => {
        fetch(`${API}/status/${currentJob.job_id}`, { headers })
          .then(r => r.json())
          .then(data => {
            setCurrentJob(data);
            if (data.status !== "running") {
              clearInterval(pollRef.current);
              loadHistory();
            }
          })
          .catch(() => clearInterval(pollRef.current));
      }, 4000);
    }
    return () => clearInterval(pollRef.current);
  }, [currentJob?.job_id, currentJob?.status]);

  function loadHistory() {
    fetch(`${API}/history`, { headers })
      .then(r => r.json())
      .then(setHistory)
      .catch(() => {});
  }

  function getPeriodDates() {
    if (customPeriod && dateFrom && dateTo) {
      return { from: dateFrom, to: dateTo };
    }
    return monthOptions[periodIdx];
  }

  async function handleRun() {
    if (!selectedBk) return;
    setError(""); setLoading(true);
    const period = getPeriodDates();
    if (!period) { setError("Укажите период"); return; }
    const hotel_ids = selectedHotel === "all" ? [] : [parseInt(selectedHotel)];
    try {
      const res = await fetch(`${API}/run`, {
        method: "POST", headers,
        body: JSON.stringify({
          bk_slug: selectedBk,
          date_from: period.from,
          date_to: period.to,
          use_qwen: useQwen,
          hotel_ids,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Ошибка запуска");
      setCurrentJob(data);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleUpload() {
    if (!selectedBk || !uploadFile || selectedHotel === "all") {
      setError("Выберите БК, конкретный отель и загрузите файл"); return;
    }
    setError(""); setLoading(true);
    const period = getPeriodDates();
    if (!period) { setError("Укажите период"); return; }
    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("bk_slug", selectedBk);
    formData.append("hotel_id", selectedHotel);
    formData.append("date_from", period.from);
    formData.append("date_to", period.to);
    formData.append("use_qwen", useQwen);
    try {
      const res = await fetch(`${API}/upload`, {
        method: "POST",
        headers: { "Authorization": `Bearer ${token}` },
        body: formData,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || "Ошибка загрузки");
      setCurrentJob(data);
      setUploadFile(null);
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleDownload(jobId) {
    try {
      const res = await fetch(`${API}/download/${jobId}`, { headers });
      if (!res.ok) throw new Error("Ошибка скачивания");
      const blob = await res.blob();
      const url  = window.URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = `reconciliation_${jobId}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch(e) {
      setError(e.message);
    }
  }

  const isRunning = currentJob?.status === "running";
  const roleLabel = { superadmin:"Супер Админ", accountant:"Бухгалтер", ota_manager:"ОТА Менеджер" };

  return (
    <div className="recon-app">
      {/* Sidebar */}
      <aside className="recon-sidebar">
        <div className="recon-sidebar-logo">
          <span className="recon-logo-icon">⬡</span>
          <div>
            <div className="recon-logo-title">THOTH AI</div>
            <div className="recon-logo-sub">СВЕРКА БК</div>
          </div>
        </div>
        <nav className="recon-sidebar-nav">
          <div className="recon-nav-item recon-nav-item--active">
            <span>🔄</span><span>Сверка с БК</span>
          </div>
        </nav>
        <div className="recon-sidebar-footer">
          <div className="recon-user-info">
            <div className="recon-user-avatar">{user?.name?.[0] || "U"}</div>
            <div>
              <div className="recon-user-name">{user?.name}</div>
              <div className="recon-user-role">{roleLabel[user?.role] || user?.role}</div>
            </div>
          </div>
          <button className="recon-btn-logout" onClick={onLogout} title="Выйти">⏻</button>
        </div>
      </aside>

      {/* Main */}
      <main className="recon-main">
        <div className="recon-page">

          {/* Шапка */}
          <div className="recon-header">
            <h1>Сверка с букинговыми компаниями</h1>
            <span className="recon-header-sub">Автоматическая сверка TravelLine с экстранетами БК</span>
          </div>

          {/* Панель запуска */}
          <div className="recon-card">
            <h2 className="recon-card-title">Новая сверка</h2>
            <div className="recon-controls">

              <div className="recon-field">
                <label>Букинговая компания</label>
                <select value={selectedBk} onChange={e => setSelectedBk(e.target.value)} disabled={isRunning}>
                  {bkList.map(bk => <option key={bk.slug} value={bk.slug}>{bk.name}</option>)}
                </select>
              </div>

              <div className="recon-field">
                <label>Отель</label>
                <select value={selectedHotel} onChange={e => setSelectedHotel(e.target.value)} disabled={isRunning}>
                  <option value="all">🏨 Все 28 отелей</option>
                  {hotels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
                </select>
              </div>

              <div className="recon-field">
                <label>Период (по дате выезда)</label>
                <div style={{display:"flex", gap:"8px", alignItems:"center", marginBottom:"6px"}}>
                  <label className="recon-checkbox-label" style={{margin:0}}>
                    <input type="checkbox" checked={customPeriod}
                      onChange={e => setCustomPeriod(e.target.checked)} disabled={isRunning}/>
                    <span>Произвольный период</span>
                  </label>
                </div>
                {!customPeriod ? (
                  <select value={periodIdx} onChange={e => setPeriodIdx(Number(e.target.value))} disabled={isRunning}>
                    {monthOptions.map((opt, i) => <option key={i} value={i}>{opt.label}</option>)}
                  </select>
                ) : (
                  <div style={{display:"flex", gap:"8px"}}>
                    <input type="date" value={dateFrom} onChange={e => setDateFrom(e.target.value)}
                      disabled={isRunning} className="recon-date-input" placeholder="с"/>
                    <input type="date" value={dateTo} onChange={e => setDateTo(e.target.value)}
                      disabled={isRunning} className="recon-date-input" placeholder="по"/>
                  </div>
                )}
              </div>

              <div className="recon-field">
                <label className="recon-checkbox-label">
                  <input type="checkbox" checked={useQwen}
                    onChange={e => setUseQwen(e.target.checked)} disabled={isRunning} />
                  <span>Анализ расхождений (Qwen AI)</span>
                </label>
                <span className="recon-hint">Объясняет причины расхождений</span>
              </div>

              <div className="recon-field">
                <label className="recon-checkbox-label">
                  <input type="checkbox" checked={diadokMode}
                    onChange={e => { setDiadokMode(e.target.checked); setUploadMode(false); setUploadFile(null); }}
                    disabled={isRunning} />
                  <span>🔄 Через Контур Диадок</span>
                </label>
                <span className="recon-hint">Автоматически скачать отчёт агента из Диадока</span>
              </div>

              <div className="recon-field">
                <label className="recon-checkbox-label">
                  <input type="checkbox" checked={uploadMode}
                    onChange={e => { setUploadMode(e.target.checked); setDiadokMode(false); setUploadFile(null); }}
                    disabled={isRunning} />
                  <span>📁 Загрузить файл отчёта вручную</span>
                </label>
                <span className="recon-hint">PDF/Excel от БК вместо автоматического подключения</span>
              </div>

              {uploadMode && (
                <div className="recon-field">
                  <label>Файл отчёта агента (PDF)</label>
                  <input type="file" accept=".pdf,.xlsx,.xls"
                    onChange={e => setUploadFile(e.target.files[0])}
                    disabled={isRunning}
                    className="recon-file-input"
                  />
                  {uploadFile && <span className="recon-hint">✅ {uploadFile.name}</span>}
                </div>
              )}

              <button className={`recon-btn-run ${isRunning ? "recon-btn-run--loading" : ""}`}
                onClick={diadokMode ? handleRunDiadok : uploadMode ? handleUpload : handleRun}
                disabled={isRunning || loading || !selectedBk || (uploadMode && (!uploadFile || selectedHotel === "all"))}>
                {isRunning
                  ? <><span className="recon-spinner"/>Выполняется...</>
                  : "▶ Запустить сверку"}
              </button>
            </div>
            {error && <div className="recon-error">⚠️ {error}</div>}
          </div>

          {/* Текущая задача */}
          {currentJob && (
            <div className={`recon-card recon-job recon-job--${currentJob.status}`}>
              <div className="recon-job-header">
                <span className="recon-job-icon">{STATUS_ICON[currentJob.status]}</span>
                <div>
                  <div className="recon-job-title">
                    {currentJob.bk_name} · {currentJob.date_from} — {currentJob.date_to}
                  </div>
                  <div className="recon-job-status">{STATUS_LABEL[currentJob.status]}</div>
                </div>
              </div>

              {currentJob.status === "running" && (
                <div className="recon-progress">
                  <div className="recon-progress-bar"/>
                  <span>Подключаюсь к экстранету, скачиваю данные, сверяю брони...</span>
                </div>
              )}

              {currentJob.status === "done" && currentJob.summary && (
                <div className="recon-summary">
                  <div className="recon-summary-grid">
                    <div className="recon-stat recon-stat--green">
                      <span className="recon-stat-val">{currentJob.summary.ok}</span>
                      <span className="recon-stat-label">Совпадает</span>
                    </div>
                    <div className="recon-stat recon-stat--yellow">
                      <span className="recon-stat-val">{currentJob.summary.postpay}</span>
                      <span className="recon-stat-label">Постоплата</span>
                    </div>
                    <div className="recon-stat recon-stat--red">
                      <span className="recon-stat-val">{currentJob.summary.amount_diff}</span>
                      <span className="recon-stat-label">Расхождение</span>
                    </div>
                    <div className="recon-stat recon-stat--yellow">
                      <span className="recon-stat-val">{currentJob.summary.only_in_tl}</span>
                      <span className="recon-stat-label">Только в TL</span>
                    </div>
                    <div className="recon-stat recon-stat--red">
                      <span className="recon-stat-val">{currentJob.summary.only_in_bk}</span>
                      <span className="recon-stat-label">Только в БК</span>
                    </div>
                    {currentJob.summary.cancelled > 0 && (
                      <div className="recon-stat recon-stat--gray">
                        <span className="recon-stat-val">{currentJob.summary.cancelled}</span>
                        <span className="recon-stat-label">Отменена в TL</span>
                      </div>
                    )}
                  </div>

                  {currentJob.summary.total_diff_rub > 0 && (
                    <div className="recon-diff-total">
                      Общая сумма расхождений: <strong>
                        {Number(currentJob.summary.total_diff_rub).toLocaleString("ru-RU",{minimumFractionDigits:2})} ₽
                      </strong>
                    </div>
                  )}

                  <button className="recon-btn-download" onClick={() => handleDownload(currentJob.job_id)}>
                    ⬇ Скачать Excel отчёт
                  </button>
                </div>
              )}

              {currentJob.status === "error" && (
                <div className="recon-error recon-error--inline">{currentJob.error_msg}</div>
              )}
            </div>
          )}

          {/* История */}
          {history.length > 0 && (
            <div className="recon-card">
              <h2 className="recon-card-title">История сверок</h2>
              <table className="recon-history-table">
                <thead>
                  <tr>
                    <th>Запущена</th><th>Кем</th><th>БК</th><th>Период</th>
                    <th>Статус</th><th>Совп.</th><th>Расх.</th><th>Сумма расх.</th><th></th>
                  </tr>
                </thead>
                <tbody>
                  {history.map(job => (
                    <tr key={job.job_id} className={`recon-history-row recon-history-row--${job.status}`}>
                      <td>{new Date(job.started_at).toLocaleString("ru-RU",{day:"2-digit",month:"2-digit",hour:"2-digit",minute:"2-digit"})}</td>
                      <td>{job.started_by_name || "—"}</td>
                      <td>{job.bk_name}</td>
                      <td>{job.date_from} — {job.date_to}</td>
                      <td><span className={`recon-badge recon-badge--${job.status}`}>{STATUS_ICON[job.status]} {STATUS_LABEL[job.status]}</span></td>
                      <td className="recon-td-num recon-td-green">{job.summary?.ok ?? "—"}</td>
                      <td className="recon-td-num recon-td-red">{job.summary?.amount_diff ?? "—"}</td>
                      <td className="recon-td-num recon-td-red">
                        {job.summary?.total_diff_rub
                          ? `${Number(job.summary.total_diff_rub).toLocaleString("ru-RU")} ₽`
                          : "—"}
                      </td>
                      <td>{job.download_url &&
                        <button className="recon-btn-dl-small" onClick={() => handleDownload(job.job_id)}>⬇ Excel</button>
                      }</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
